import {Selector} from '@ngxs/store';
import {DisplayType} from '../../../modules/users/models/DisplayType';
import {FilterObject} from '../../../shared/models/FilterBarObject';
import {User, UserName} from '../../models/user/user.interface';
import {UserConfigurationMetaData} from '../../models/user/users-query-result';
import {UserFilter, UsersStateModel} from './users.model';
import {UsersState} from './users.state';

export class UsersSelectors {
  @Selector([UsersState])
  static isTouched(state: UsersStateModel): boolean {
    return state.isTouched;
  }

  @Selector([UsersState])
  static currentChunk(state: UsersStateModel): number {
    return state.currentPage;
  }

  @Selector([UsersState])
  static userFilter(state: UsersStateModel): FilterObject<UserFilter> {
    return state.userFilter;
  }


  @Selector([UsersState])
  static users(state: UsersStateModel): User[] {
    return state.users;
  }

  @Selector([UsersState])
  static idHoldersName(state: UsersStateModel): UserName[] {
    return state.idHoldersName;
  }


  @Selector([UsersState])
  static usersCount(state: UsersStateModel): number {
    return state.totalUsersCount;
  }


  @Selector([UsersState])
  static selectedUser(state: UsersStateModel): User {
    return state.selectedUser;
  }


  @Selector([UsersState])
  static displayType(state: UsersStateModel): DisplayType {
    return state.displayType;
  }

  @Selector([UsersState])
  static configuration(state: UsersStateModel): UserConfigurationMetaData {
    return state.configuration;
  }

  @Selector([UsersState])
  static isLoadingData(state: UsersStateModel): boolean {
    return state.isLoadingData;
  }
  @Selector([UsersState])
  static getPermissions(state: UsersStateModel): any {
    return state.permissions;
  }
}
